
const digest = 'a5a87f9c05132958ff07f3ade6f29752b097dafa5c39176bb5726f1d371982cb';
const classes = {"wrapper":"_wrapper_1dz0h_1","input":"_input_1dz0h_4","withSuffix":"_withSuffix_1dz0h_17","unit":"_unit_1dz0h_27"};
const css = `._wrapper_1dz0h_1 {
  position: relative;
}
._wrapper_1dz0h_1 ._input_1dz0h_4 {
  border: 1px solid #c1cbe4 !important;
  min-height: 55px;
  font-size: 14px;
  font-weight: 400;
  border-radius: 15px;
  box-shadow: inset 0 3px 0 0 rgba(198, 214, 240, 0.5);
  padding: 16px 40px 16px 20px !important;
  color: #000;
  background-color: #dce7fa;
  position: relative;
  width: 100%;
}
._wrapper_1dz0h_1 ._withSuffix_1dz0h_17 {
  padding-right: 60px !important;
}
._wrapper_1dz0h_1 img {
  height: 16px;
  position: absolute;
  right: 20px;
  top: calc(50% - 8px);
  cursor: pointer;
}
._wrapper_1dz0h_1 ._unit_1dz0h_27 {
  position: absolute;
  font-size: 14px;
  right: 25px;
  bottom: 17px;
  border-left: 1px solid #c1cbe4;
  height: 100%;
  top: 0;
  display: flex;
  align-items: center;
  padding-left: 15px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  